import type { IBackwardCompatibilityHandler } from './CasePersistenceHub';
import type { IStateMetadata } from '@/engine/app/CasePhaseData/interfaces.ts';

export class CasePhaseDataCompatibilityHandler implements IBackwardCompatibilityHandler {
  private _handleMetadata10(metadata: unknown): unknown {
    const metaIn = metadata as Array<{
      kind: string;
      kindInfo: {
        activePhaseId: string;
        availablePhases: Array<{
          id: string;
          name: string;
        }>;
      };
    }>;
    const metaOut: IStateMetadata = {
      phaseKinds: metaIn.map((val) => {
        return {
          kind: val.kind,
          kindInfo: {
            phaseImports: [],
            activePhaseId: val.kindInfo.activePhaseId,
            availablePhases: val.kindInfo.availablePhases.map((value) => {
              return {
                id: value.id,
                name: value.name,
                params: [
                  { name: 'rvVolume', value: 10000 },
                  { name: 'annulusSize', value: 10 }
                ]
              };
            }),
            params: []
          }
        };
      }),
      phaseStates: []
    };
    return metaOut;
  }

  private _handleMetadata11And12(metadata: unknown): unknown {
    const metaIn = metadata as {
      phaseKinds: Array<{
        kind: string;
        kindInfo: {
          phaseImports: Array<string>;
          activePhaseId: string;
          availablePhases: Array<{
            id: string;
            name: string;
            params?: Record<string, number>;
          }>;
        };
      }>;
      phaseStates: Array<{
        id: string;
        values: Array<{
          name: string;
          type: string;
          value?: unknown;
        }>;
      }>;
    };
    const metaOut: IStateMetadata = {
      phaseKinds: metaIn.phaseKinds.map((val) => {
        return {
          kind: val.kind,
          kindInfo: {
            phaseImports: val.kindInfo.phaseImports,
            activePhaseId: val.kindInfo.activePhaseId,
            availablePhases: val.kindInfo.availablePhases.map((value) => {
              return {
                id: value.id,
                name: value.name,
                params: value.params
                  ? Array.from(Object.entries(value.params)).map((v) => ({ name: v[0], value: v[1] }))
                  : []
              };
            }),
            phaseParamsDescriptor: undefined,
            params: []
          }
        };
      }),
      phaseStates: metaIn.phaseStates.map((entry) => ({ id: entry.id, values: entry.values, approvedNames: [] }))
    };
    return metaOut;
  }

  public handleMetadata(metadata: unknown, version?: string): Promise<unknown> {
    if (version === undefined) {
      throw new Error('Logic error');
    }
    if (version == '1.0') {
      return Promise.resolve(this._handleMetadata10(metadata));
    }
    if (version == '1.1') {
      return Promise.resolve(this._handleMetadata11And12(metadata));
    }
    if (version == '1.2') {
      return Promise.resolve(this._handleMetadata11And12(metadata));
    }
    throw new Error('Logic error');
  }
}
